import { combineReducers } from 'redux';
import { mainReducer } from './reducer';

export default combineReducers({
  main: mainReducer
});



/** WEBPACK FOOTER **
 ** ./src/store/reducer.js
 **/